module.exports = __webpack_public_path__ + "assets/GoldChi.525ffb7d62d4cb4c3af157de8b3208f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldChi.png
// module id = 758
// module chunks = 0